import { FooterComponent, GalleryItem } from "./"
import '../styles/Gallery.css'


export const GalleryComponent = () => {
  const titles = ['Monumento 21 (Bilbao)', 'Monumento 69 (El Baul)', 'Chocolatera (Río Azúl)', 'Takalik Abaj', 'Municipalidad de Retalhuleu',
                  'Volcanes', 'Santa María & Santiaguito', 'Incensario Tehotihuacano', 'Pochas de Cacao', 'Granos de Cacao', 'Calzada de Las Palmas',
                  'Parroquia San Antonio Padua', 'Piezas de Cotz', 'Cabezas', 'Altar', 'Monumento 66', 'Monumento 68', 'Takalik Abaj',
  ];
  const imgs = [
        '../Gallery/Monumento-21-Las-Ilusiones.png',
        '../Gallery/Monumento-69-El-Baul.png',
        '../Gallery/Chocolatera-Rio-Azul.png',
        '../Gallery/takalik_abaj.jpg',
        '../Gallery/muni_reu.jpg',
        '../Gallery/volcanes.png',
        '../Gallery/Santa_Maria_Volcano.jpg',
        '../Gallery/pocha.png',
        '../Gallery/pochas.png',
        '../Gallery/granos-de-cacao.png',
        '../Gallery/las-palmas.jpg',
        '../Gallery/san-antonio-padua.jpg',
        '../Gallery/marcador.jpg',
        '../Gallery/cabezas.jpg',
        '../Gallery/altar.jpg',
        '../Gallery/monumento66.jpg',
        '../Gallery/monumento68.jpg',
        '../Gallery/mapa-takalik.png',
    ];
  return (
    <>
        <div className="canva">
            <div className="canva-row">
                {
                    titles.map( (item, i) => {
                        return (<GalleryItem Title={ item } Img={ imgs[i] } key={`${item}-${i}`} />);
                    })
                }
            </div>
        </div>
        <FooterComponent />
    </>
  )
}
